export default __webpack_public_path__ + "static/media/qordoba.83081905.svg";